module.exports = __webpack_public_path__ + "img/c2a28be.svg";